import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, resolveComponent as _resolveComponent, createBlock as _createBlock, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "fs-13px text-cool-gray-100"
}
const _hoisted_2 = {
  key: 1,
  class: "fs-13px text-cool-gray-70"
}

import translate from 'src/common/helpers/language/translate'
import globalTranslateObject from 'src/translate/global.translate'

interface IProps {
  label?: string
  labelWrapperClass?: string
  value: string
  valueWrapperClass?: string
  labelColor?: string
  border?: boolean
  solidBorder?: boolean
  fixedHeight?: boolean
}


export default /*@__PURE__*/_defineComponent({
  ...{ name: 'BaseSidePanelRecord' },
  __name: 'BaseSidePanelRecord',
  props: {
    label: { default: '' },
    labelWrapperClass: { default: 'items-center' },
    value: {},
    valueWrapperClass: { default: 'items-center' },
    labelColor: { default: 'cool-gray-80' },
    border: { type: Boolean, default: true },
    solidBorder: { type: Boolean, default: false },
    fixedHeight: { type: Boolean, default: true }
  },
  setup(__props: any) {




const { t: globalT } = translate(globalTranslateObject)

return (_ctx: any,_cache: any) => {
  const _component_k_divider = _resolveComponent("k-divider")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: _normalizeClass(["BaseSidePanelRecord flex justify-between q-px-sm", [{ 'BaseSidePanelRecord--fixed-height': __props.fixedHeight }, _ctx.$attrs.class]])
    }, [
      (__props.label)
        ? (_openBlock(), _createElementBlock("div", {
            key: 0,
            class: _normalizeClass(["flex", __props.labelWrapperClass])
          }, [
            _createElementVNode("span", {
              class: _normalizeClass(["fs-13px", `text-${__props.labelColor}`])
            }, _toDisplayString(__props.label), 3 /* TEXT, CLASS */),
            _renderSlot(_ctx.$slots, "left")
          ], 2 /* CLASS */))
        : _createCommentVNode("v-if", true),
      _createElementVNode("div", {
        class: _normalizeClass(["flex", __props.valueWrapperClass])
      }, [
        _renderSlot(_ctx.$slots, "right", {}, () => [
          (__props.value)
            ? (_openBlock(), _createElementBlock("span", _hoisted_1, _toDisplayString(__props.value), 1 /* TEXT */))
            : (_openBlock(), _createElementBlock("span", _hoisted_2, _toDisplayString(_unref(globalT)('not_available')), 1 /* TEXT */))
        ])
      ], 2 /* CLASS */)
    ], 2 /* CLASS */),
    (__props.border)
      ? (_openBlock(), _createBlock(_component_k_divider, {
          key: 0,
          class: "q-my-12",
          size: __props.solidBorder ? 'md' : 'sm',
          dotted: !__props.solidBorder,
          color: __props.solidBorder ? 'cool-gray-30' : 'cool-gray-50'
        }, null, 8 /* PROPS */, ["size", "dotted", "color"]))
      : _createCommentVNode("v-if", true)
  ], 64 /* STABLE_FRAGMENT */))
}
}

})